module.exports = __webpack_public_path__ + "static/img/govInfoLink.367a2ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/govInfoLink.png
// module id = 1CB6
// module chunks = 0